import { getLocale } from "../runtime";

const sv_packagedelivered = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `När ditt paket har levererats får du ett meddelande från fraktbolaget.`
};

const packagedelivered = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_packagedelivered(inputs)
	return "packageDelivered";
};

export { packagedelivered as "packageDelivered" };